// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-control h2[data-v-7537da49]{padding-top:2px}.personalize-img[data-v-7537da49]{margin-left:-2rem}.personalize-text[data-v-7537da49]{text-overflow:scale}p[data-v-7537da49]{font-size:1.3rem;line-height:1.3}.fs-18[data-v-7537da49]{font-size:18px}@media(min-width:768px){.fs-lg-24[data-v-7537da49]{font-size:24px}}.fs-16[data-v-7537da49]{font-size:16px}", ""]);
// Exports
module.exports = exports;
